export function middleClickDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: middleClickDirectiveCtrl,
	};
}

// inspired by https://github.com/thiagofaleiro/ng-middle-click/blob/v0.0.1/src/ng-middle-click.js
export class middleClickDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		this.$attrs = $attrs;
		this.handleClick = this.handleClick.bind(this);
		// see https://caniuse.com/#search=auxclick for support of auxclick event
		const eventType = 'onauxclick' in document.documentElement ? 'auxclick' : 'click';
		// add and remove listeners
		$element.on(eventType, this.handleClick);
		$scope.$on('$destroy', () => {
			$element.off(eventType, this.handleClick());
		});
	}

	handleClick(evt) {
		// 2 for middle button (as opposed to right click)
		if (evt && evt.which === 2) {
			this.$scope.$eval(this.$attrs.shMiddleClick || this.$attrs.ngClick, { $event: evt });
		}
	}
}
